/*
 * @Autor: syq
 * @Date: 2021-07-15 16:48:17
 */
import request from "../../request/request";
import { stringify } from "qs";

// 根据店铺名称查询店铺及其商品列表
const queryTreeNode = async (params) =>
  request({
    url: `/realStore/realStore?${stringify(params)}`,
    method: "get",
  });
export { queryTreeNode };
